/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of receipt being requested.
 */
export const ReceiptKind = {
  SaleCustomerV1: "sale.customer.v1",
} as const;
/**
 * The type of receipt being requested.
 */
export type ReceiptKind = ClosedEnum<typeof ReceiptKind>;

/** @internal */
export const ReceiptKind$inboundSchema: z.ZodNativeEnum<typeof ReceiptKind> = z
  .nativeEnum(ReceiptKind);
/** @internal */
export const ReceiptKind$outboundSchema: z.ZodNativeEnum<typeof ReceiptKind> =
  ReceiptKind$inboundSchema;
